enum ValidateSSOUserCode {
    invalidUser= '1',
    requestCreated= '2',
    requestPending= '3',
    validUser= '4',
}

export default ValidateSSOUserCode;